import React from 'react';

/**
 * KPI card skeleton — large number placeholder (top), small label (bottom),
 * optional sparkline placeholder on the right side.
 *
 * Uses a slow dedicated shimmer (2.2s via skeleton-shimmer keyframe).
 * Height matches final KPI cards, content is vertically centered.
 *
 * When `title` is provided from the plan preview, it replaces the
 * shimmer label with the real KPI title text.
 */
interface KPISkeletonProps {
  /** Real KPI title from plan preview. */
  title?: string;
}

const KPISkeleton: React.FC<KPISkeletonProps> = ({ title }) => (
  <div className="skeleton-chart-container">
    <div className="kpi-skeleton">
      <div className="kpi-skeleton__left">
        {title ? (
          <div className="chart-skeleton__real-title chart-skeleton__real-title--kpi">{title}</div>
        ) : (
          <div className="kpi-skeleton__label" />
        )}
        <div className="kpi-skeleton__value" />
        <div className="kpi-skeleton__change" />
      </div>
      <div className="kpi-skeleton__sparkline" />
    </div>
  </div>
);

export default React.memo(KPISkeleton);